import { Link } from "react-router-dom";
const Header = () => {
    function cerrar() {
        console.log("Cerrar menu");
        let navbar = document.querySelector(".navbar-toggler");
        navbar.click();
    }
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item ">
                                {window.screen.width < 1024 ? <Link className="nav-link textColor text-center" to="/" onClick={cerrar}>INICIO</Link> : <Link className="nav-link textColor Separador" to="/"  >INICIO</Link>}
                            </li>
                            <li className="nav-item">
                                {window.screen.width < 1024 ? <Link className="nav-link textColor text-center" to="/Bases" onClick={cerrar}>BASES</Link> : <Link className="nav-link textColor Separador" to="/Bases"  >BASES</Link>}
                            </li>
                            <li className="nav-item">
                                {window.screen.width < 1024 ? <Link className="nav-link textColor text-center" to="/Galeria" onClick={cerrar}>GALERÍA</Link> : <Link className="nav-link textColor Separador" to="/Galeria"  >GALERÍA</Link>}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}
export default Header;